export const SET_PREVIEW_MUTATION = 'SET_PREVIEW_MUTATION';
export const SET_PREVIEW = 'SET_PREVIEW';
